import { ComponentType } from 'react';

import { useAppSelector } from '../../../../../../store/hooks';
import { OuterCampaignFiltersProps } from '../../models/outer-campaign-filters.props';

export const withCampaignFilterValues = <
  TProps extends OuterCampaignFiltersProps
>(
  WrappedComponent: ComponentType<TProps>
): ((props: Omit<TProps, 'campaignSelectFilters'>) => JSX.Element) => {
  return (props: Omit<TProps, 'campaignSelectFilters'>) => {
    const campaignSelectFiltersState = useAppSelector(
      state => state.campaignsFeature.campaigns.filters.header
    );

    return (
      <WrappedComponent
        {...(props as TProps)}
        campaignSelectFilters={campaignSelectFiltersState}
      />
    );
  };
};
